import { Dialog, DialogTitle, Transition, TransitionChild } from "@headlessui/react";
import React, { Fragment } from "react";
import { XMarkIcon } from '@heroicons/react/24/solid';
import AuthDialogContent from "./AuthDialogContent";
import { useAppContext } from "../../context/AppContext";

interface AuthDialogProps {
    isOpen: boolean
    onClose: () => void,
    allowClose: boolean
}

const AuthDialog: React.FC<AuthDialogProps> = ({ isOpen, onClose, allowClose:_allowClose }) => {

    const {isOnline} = useAppContext();

    const allowClose = _allowClose && [true, "true", 1, "1"].includes(import.meta.env.VITE_ALLOW_GUEST);

    const allowSignUp:boolean=[true,"true",1,"1"].includes(import.meta.env.VITE_ALLOW_SIGNUP);

    const handleBackdropClick = (event: React.MouseEvent<HTMLDivElement>) => {
        if (event.target === event.currentTarget && allowClose) {
            onClose();
        }
    };

    return <Transition show={isOpen} as={Fragment}>
        <Dialog as="div" className="fixed inset-0 z-30 overflow-y-auto " onClose={() => onClose()}>
            <div className="flex items-center justify-center min-h-screen bg-gray-800 bg-opacity-75 p-4" onClick={handleBackdropClick}>
                <TransitionChild
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0 scale-95"
                    enterTo="opacity-100 scale-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100 scale-100"
                    leaveTo="opacity-0 scale-95"
                >
                    <div className="bg-white  dark:bg-gray-900 dark:text-gray-100 p-6 max-w-md rounded-lg shadow-lg w-full space-y-4" onClick={(e) => e.stopPropagation()}>
                        <DialogTitle className="text-lg font-semibold text-gray-900 dark:text-gray-100 flex justify-between items-center">
                            <div className="w-full text-right">
                                {allowClose &&
                                    <button onClick={() => onClose()} className="text-gray-500 hover:text-gray-700 dark:hover:text-gray-300">
                                        <XMarkIcon className="h-6 w-6" />
                                    </button>
                                }
                            </div>
                        </DialogTitle>
                        {!isOnline &&
                            <div className="bg-red-100 dark:bg-red-900 px-4 py-2 rounded-nd">You are offline</div>
                        }
                        <AuthDialogContent onClose={onClose} initialView={(localStorage.getItem("hasAccount") || !allowSignUp) ? 'login' : 'signup'} />
                    </div>
                </TransitionChild>
            </div>
        </Dialog>
    </Transition>
}

export default AuthDialog;